import React from 'react'

import { cn } from '~/styled'

import { Tile } from '../tile/Tile'
import { SkeletonLoader } from './Skeleton'

const getBarHeight = (groupIndex: number, columnIndex: number) =>
  Math.round(90 + Math.abs(Math.sin(groupIndex + columnIndex + 1)) * 30)

const ColumnGroup = ({
  numberOfColumns,
  groupIndex
}: {
  numberOfColumns: number
  groupIndex: number
}) => (
  <div className="flex flex-col items-center gap-4">
    <div className="flex items-end gap-2">
      {Array.from({ length: numberOfColumns }, (_, i) => (
        <SkeletonLoader
          key={i}
          className="h-(--height) w-5 rounded-t-full rounded-b-none"
          style={{
            '--height': `${getBarHeight(groupIndex, i)}px`
          }}
        />
      ))}
    </div>
    <SkeletonLoader className="h-2 w-14 rounded-full" />
  </div>
)

const LegendItem = () => (
  <div className="flex items-center gap-2">
    <SkeletonLoader className="h-3 w-3 rounded-full" />
    <SkeletonLoader className="h-3 w-24 rounded-full" />
  </div>
)

export const SkeletonColumnChart = ({
  numberOfLabels = 2,
  numberOfGroups = 7,
  numberOfColumns = 1,
  className
}: {
  numberOfLabels?: number
  numberOfGroups?: number
  numberOfColumns?: number
  className?: string
}) => (
  <Tile className={cn('p-6', 'flex-col', 'gap-6', 'w-full', className)}>
    <div className="flex flex-col gap-3">
      <div className="flex items-center gap-4">
        {Array.from({ length: numberOfLabels }, (_, i) => (
          <LegendItem key={i} />
        ))}
      </div>
    </div>
    <div className="flex items-end justify-between gap-2">
      {Array.from({ length: numberOfGroups }, (_, i) => (
        <ColumnGroup key={i} numberOfColumns={numberOfColumns} groupIndex={i} />
      ))}
    </div>
  </Tile>
)
